module.exports = __webpack_public_path__ + "static/image1_fr-983a63845d67b2caff8480a14ef613bf.png";